import { useParams } from "next/navigation"

export default function useBaseBlogUrl() {
  const params = useParams()

  // Otherwise, we want to link to the blog post.
  let blogSlugUrl
  if (params && "blogSlug" in params) {
    blogSlugUrl = `${decodeURIComponent(params.blogSlug as string)}`
  }

  return blogSlugUrl as string
}
